import classNames from 'classnames';
export default function MaximizeIcon({ size = 24, color, className }) {
    return (<svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className={classNames('fill-current', className, color)}>
      <path d="M6.56827 2.34785V6.56827H2.54537V11.8025H12V2.34785H6.56827ZM11.3336 10.0537H10.2836V11.1037H9.53713V10.0537H8.48701V9.30735H9.53713V8.2571H10.2836V9.30735H11.3336V10.0537Z" fill="currentColor"/>
      <path d="M5.81823 0H0V5.81823H5.81823V0ZM4.86371 4.86358H0.954513V0.954381H4.86371V4.86358Z" fill="currentColor"/>
    </svg>);
}
